import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'
import { useFetchRelayInfo } from '@/hooks/useFetchRelayInfo'
import { cn } from '@/lib/utils'
import { HugeiconsIcon } from '@hugeicons/react'
import { ServerStack01Icon } from '@hugeicons/core-free-icons'
import { useMemo } from 'react'

export default function RelayIcon({
  url,
  className,
  iconSize = 14
}: {
  url?: string
  className?: string
  iconSize?: number
}) {
  const { relayInfo } = useFetchRelayInfo(url ?? '')
  const iconUrl = useMemo(() => {
    if (relayInfo?.icon) {
      return relayInfo.icon
    }
    if (!url) return
    const u = new URL(url)
    return `${u.protocol === 'wss:' ? 'https:' : 'http:'}//${u.host}/favicon.ico`
  }, [url, relayInfo])

  return (
    <Avatar className={cn('w-6 h-6', className)}>
      <AvatarImage src={iconUrl} className="object-cover object-center" />
      <AvatarFallback>
        <HugeiconsIcon icon={ServerStack01Icon} size={iconSize} />
      </AvatarFallback>
    </Avatar>
  )
}
